module.exports = __webpack_public_path__ + "static/media/target.a3215707.svg";